export default "__VITE_ASSET__J4PRRhIn__"